import { render } from "./LoadingMessage.vue?vue&type=template&id=777eb6b0"
const script = {}

import "./LoadingMessage.vue?vue&type=style&index=0&id=777eb6b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__